import { render, staticRenderFns } from "./Heartbeats.vue?vue&type=template&id=f4b66418&"
import script from "./Heartbeats.vue?vue&type=script&lang=ts&"
export * from "./Heartbeats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports